<template>
  <client-only>
    <v-skeleton-loader v-if="props.isUserInfoSkeletonShown" v-bind="skeletonProps" />
    <template v-else>
      <v-img
        v-if="facebookAvatarUrl"
        class="wd-rounded-full"
        :class="facebookAvatarClassName"
        :max-width="props.avatarSize"
        :height="props.avatarSize"
        width="100%"
        cover
        :src="facebookAvatarUrl"
      />
      <funnow-icon v-else :active-class="props.avatarClass" :image-path="avatarImagePath" />
    </template>

    <template #fallback>
      <v-skeleton-loader v-bind="skeletonProps" />
    </template>
  </client-only>
</template>

<script lang="ts" setup>
import { useAvatar } from '@/composition/useMember'
import { usePlatformStore } from '@/store-pinia/platform'
import { RegisterTypeEnum } from '@/view-models/authentication'
import FunnowIcon from '@/components/icons/funnow-icon.vue'

interface Props {
  isLimitedPlatform: boolean
  isUserInfoSkeletonShown: boolean
  avatarSize?: number | string
  avatarClass?: ClassType
}

const props = defineProps<Props>()

const { $store: store } = useNuxtApp()
const platformStore = usePlatformStore()
const { isFunBookV2 } = storeToRefs(platformStore)

const user = computed(() => store.getters['authentication/getUser'])

const { avatarImagePath, avatarBorderClass } = useAvatar(user, isFunBookV2)

const skeletonProps = computed(() => ({ class: `wd-rounded-full wd-mx-auto ${props.avatarClass}`, type: 'ossein' }))
const facebookAvatarClassName = computed(() => {
  if (props.isLimitedPlatform) {
    return ''
  }
  return `wd-border-solid wd-border-2 ${avatarBorderClass.value}`
})
const facebookAvatarUrl = computed(() => {
  if (user.value?.auth_type === RegisterTypeEnum.Facebook) {
    const fbId = user.value?.account.split('@')[0]
    return `https://graph.facebook.com/${fbId}/picture?type=large&width=240&height=240`
  }
  return ''
})
</script>
